import React from 'react';
import { Link } from 'react-router-dom';
import Routes from '../../../routes';

export const FooterTableButton = ({ baseUrl, colSpan, onSave }) => (
    <tr>
        <td colSpan={colSpan}>
            <button className="btn btn-custom-theme float-right" type="button" onClick={onSave}><i className="far fa-save"></i></button>
            <Link to={`${baseUrl}${Routes.Home}`} className="btn btn-custom-theme float-right">
                <i className="fas fa-angle-double-left"></i>
            </Link>
        </td>
    </tr>
);


// WEBPACK FOOTER //
// ./Public/src/js/component/parametro/children/footer-table-button.jsx